import { AsyncPipe, CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { StatusButtonGroupComponent } from "../shared/components/status-button-group.component";
import {
  HideAssignStatusAction,
  PlanningState,
} from "../shared/store/planning.state";
import { Assignment, AssignmentStatus } from "./../shared/model/model";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-assign-status",
  templateUrl: "assign-status.component.html",
  standalone: true,
  imports: [
    CommonModule,
    AsyncPipe,
    TranslateModule,
    StatusButtonGroupComponent,
  ],
})
export class AssignStatusComponent {
  lastAssignment = null;
  assignment$: Observable<Assignment>;
  planState = AssignmentStatus.Assigned;
  unplanState = AssignmentStatus.Unassigned;
  markFailState = AssignmentStatus.FailedManually;
  markPassState = AssignmentStatus.PassedManually;
  constructor(
    private store: Store,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.assignment$ = this.store.select(PlanningState.selectedAssignment).pipe(
      map((a) => {
        if (a.status === AssignmentStatus.Unassigned) {
          this.close();
        }
        return a;
      })
    );
  }
  close = () => this.store.dispatch(new HideAssignStatusAction());
  showDetails = (id: string) => {
    this.router.navigate([`details/${id}`], { relativeTo: this.route });
    this.close();
  };
  onClickedOutside = (assignment: Assignment) => {
    // check on last knowm assessment. this is needed because:
    // - first click is the click that should open the dialog. this should be ignored and will be because lastAssignment = null;
    // - if another assignment is clicked, it shouldn't be closed.
    if (this.lastAssignment === assignment) {
      this.close();
    }
    this.lastAssignment = assignment;
  };
}
